import styles from "./domainScreenBackground.module.scss";

/** Базовый доменный фон (шлюзы: авторизация и т.п.) — сплошной тёмный, без градиента доп. экрана */
export function DomainScreenBackground() {
  return <div className={styles.root} aria-hidden />;
}
